<template>
    <div class="main">
        <transition v-if="$route.name !== 'canvasser-register.restart-account'">
            <router-view name="registerSubNavigation"/>
        </transition>
        <transition v-else>
            <h1 style="text-align: center">Restart Account Page</h1>
        </transition>
        <transition>
            <router-view/>
        </transition>
    </div>
</template>
<script>

export default {
    name: 'Canvasser',
    mounted() {
        this.$store.dispatch('account/fetchUserData', true);
    },
};
</script>
